import {
    ALL_TRANSACTION_LIST_START,
    ALL_TRANSACTION_LIST_SUCCESS,
    ALL_TRANSACTION_LIST_ERROR,
    PENDING_TRANSACTION_LIST_START,
    PENDING_TRANSACTION_LIST_SUCCESS,
    PENDING_TRANSACTION_LIST_ERROR,
    COMPLETED_TRANSACTION_LIST_START,
    COMPLETED_TRANSACTION_LIST_SUCCESS,
    COMPLETED_TRANSACTION_LIST_ERROR,
    GET_PANALTY_PAYMENT_DETAIL_SUCCESS,
    GET_PANALTY_PAYMENT_DETAIL_ERROR,
    GET_PANALTY_PAYMENT_DETAIL_START
} from "Constant";

const initialState = {
    loading: false,
    allTransactionListData: {},
    pendingTransactionListData: {},
    completedTransactionListData: {},
    panaltyTransactionListData:[]

};
export default function OperatorTransactionListReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case ALL_TRANSACTION_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case ALL_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                allTransactionListData: action.payload,
                loading: false,
            };
        case ALL_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case PENDING_TRANSACTION_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case PENDING_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                pendingTransactionListData: action.payload,
                loading: false,
            };
        case PENDING_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case COMPLETED_TRANSACTION_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case COMPLETED_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                completedTransactionListData: action.payload,
                loading: false,
            };
        case COMPLETED_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
            case GET_PANALTY_PAYMENT_DETAIL_START:
            return {
                ...state,
                loading: true,
            };
        case GET_PANALTY_PAYMENT_DETAIL_SUCCESS:
            return {
                ...state,
                panaltyTransactionListData: action.payload,
                loading: false,
            };
        case GET_PANALTY_PAYMENT_DETAIL_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

